document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('page-become-an-affiliate')) {
    var introduction = document.querySelector('.collabs-page__intro > p');
    if (introduction) {
      introduction.textContent = 'Shimmer & Confetti is a family-run Canadian brand creating party details, custom pieces and celebration essentials that help every gathering feel more personal.';
    }
  }

  var contentPage = document.querySelector('[data-template-page]');
  if (contentPage) {
    var pageHeading = contentPage.querySelector('h1');
    var pageAlt = pageHeading && pageHeading.textContent.trim()
      ? pageHeading.textContent.trim()
      : document.title.split('|')[0].trim();

    contentPage.querySelectorAll('.sc-page-richtext img, .sc-generic-page__content img').forEach(function (image) {
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.alt || !image.alt.trim()) image.alt = pageAlt;
    });
  }

  var articlePage = document.querySelector('.sc-article-page');
  if (!articlePage) return;

  var fallbackImage = articlePage.getAttribute('data-fallback-image');
  var fallbackAlt = articlePage.getAttribute('data-fallback-alt') || 'Shimmer & Confetti party guide';
  var contentImages = articlePage.querySelectorAll('.sc-article-content img');

  contentImages.forEach(function (image, index) {
    image.loading = index === 0 ? 'eager' : 'lazy';
    image.decoding = 'async';
    if (!image.alt || !image.alt.trim()) image.alt = fallbackAlt;

    var recoverImage = function () {
      if (!fallbackImage || image.src === fallbackImage) {
        image.hidden = true;
        return;
      }

      image.removeAttribute('srcset');
      image.src = fallbackImage;
      image.alt = fallbackAlt;
      image.classList.add('sc-article-image--recovered');
    };

    image.addEventListener('error', recoverImage, { once: true });
    if (image.complete && image.naturalWidth === 0) recoverImage();
  });
});
